import { useEffect } from 'react';
import { getFaqChannels, selectFaqChannels, selectFaqChannelsError, selectFaqChannelsIsLoading } from '../feature';
import { useAppDispatch, useAppState } from '@/store';

export const useGetFaqChannels = () => {
  const dispatch = useAppDispatch();
  const channels = useAppState(selectFaqChannels);
  const isLoading = useAppState(selectFaqChannelsIsLoading);
  const error = useAppState(selectFaqChannelsError);

  useEffect(() => {
    if (!channels && !isLoading && !error) {
      dispatch(getFaqChannels());
    }
  }, [channels, isLoading, error, dispatch]);

  return { channels, isLoading, error };
};
